"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./MarketingHeader.css");

var _react = _interopRequireDefault(require("react"));

var _map = _interopRequireDefault(require("lodash/map"));

var _FlyoutTile = _interopRequireDefault(require("../../gradifui/components/header/FlyoutTile"));

var _LabelledItem = _interopRequireDefault(require("../../gradifui/components/header/LabelledItem"));

var _LogoItem = _interopRequireDefault(require("../../gradifui/components/header/LogoItem"));

var _BaseHeader = _interopRequireDefault(require("../../gradifui/components/header/BaseHeader"));

var _RequestDemoButton = _interopRequireDefault(require("../../shared/components/marketing/RequestDemoButton"));

var _constants = require("../../util/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var flyoutTileData = [{
  tileName: "Overview",
  tileDescription: "See the whole Gradifi suite of solutions.",
  additionalClass: "product-overview",
  imgAlt: "Gradifi Product Overview",
  imgPath: require("../assets/redesign2020/product-overview-border.png"),
  url: _constants.URLS.MARKETING.PRODUCTS
}, {
  tileName: "FinancialCore",
  tileDescription: "Empower your employees with tools and resources.",
  additionalClass: "fincore",
  imgAlt: "Financial Core",
  imgPath: require("../assets/redesign2020/fincore-border-logo.png"),
  url: _constants.URLS.MARKETING.REFI
}, {
  tileName: "Student Loan PayDown",
  tileDescription: "Help employees pay down student loans.",
  additionalClass: "slp",
  imgAlt: "Student Loan PayDown",
  imgPath: require("../assets/redesign2020/slp-border-logo.png"),
  url: _constants.URLS.MARKETING.PAYDOWN
}, {
  tileName: "College SaveUp",
  tileDescription: "Offer employees solutions to save for their children's education.",
  additionalClass: "csu",
  imgAlt: "College SaveUp",
  imgPath: require("../assets/redesign2020/csu-border-logo.png"),
  url: _constants.URLS.MARKETING.SAVEUP
}];

var _default = function _default(_ref) {
  var isLoggedIn = _ref.isLoggedIn,
      requestInfoUrl = _ref.requestInfoUrl;

  var mobileMenuRender = function mobileMenuRender() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "marketing-header-mobile"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "products"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: "product-header-checkbox",
      type: "checkbox",
      id: "marketing-header-mobile-checkbox",
      "aria-label": "Product Dropdown Button"
    }), /*#__PURE__*/_react.default.createElement("label", {
      className: "product-header",
      "aria-hidden": "true",
      htmlFor: "marketing-header-mobile-checkbox"
    }, "Solutions"), /*#__PURE__*/_react.default.createElement("div", {
      className: "product-dropdown"
    }, (0, _map.default)(flyoutTileData, function (_ref2) {
      var tileName = _ref2.tileName,
          url = _ref2.url,
          additionalClass = _ref2.additionalClass;
      return /*#__PURE__*/_react.default.createElement("a", {
        key: tileName,
        className: additionalClass,
        href: url
      }, tileName);
    }))), /*#__PURE__*/_react.default.createElement("a", {
      className: "request-demo",
      href: requestInfoUrl,
      target: "_blank"
    }, "Request A Demo"), isLoggedIn ? /*#__PURE__*/_react.default.createElement("a", {
      className: "logout",
      href: _constants.URLS.LOGOUT
    }, "Logout") : /*#__PURE__*/_react.default.createElement("a", {
      className: "login",
      href: _constants.URLS.LOGIN
    }, "Login/Register"));
  };

  return /*#__PURE__*/_react.default.createElement(_BaseHeader.default, {
    mobileRender: mobileMenuRender(),
    disableMobileTransform: true,
    disableDesktopTransform: false
  }, /*#__PURE__*/_react.default.createElement("nav", {
    className: "left-section"
  }, /*#__PURE__*/_react.default.createElement(_LogoItem.default, {
    url: _constants.URLS.HOME
  })), /*#__PURE__*/_react.default.createElement("nav", {
    className: "right-section"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "marketing-header-solutions"
  }, /*#__PURE__*/_react.default.createElement(_LabelledItem.default, {
    label: "Solutions",
    className: "solutions-link",
    icon: "icon-down-dir",
    showChildrenOnHover: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flyout-container"
  }, (0, _map.default)(flyoutTileData, function (props) {
    return /*#__PURE__*/_react.default.createElement(_FlyoutTile.default, _extends({
      key: props.tileName
    }, props));
  })))), isLoggedIn && /*#__PURE__*/_react.default.createElement(_LabelledItem.default, {
    label: "Log Out",
    url: _constants.URLS.LOGOUT
  }), !isLoggedIn && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "btn-demo-header-mobile btn-demo-header"
  }, /*#__PURE__*/_react.default.createElement(_RequestDemoButton.default, {
    url: requestInfoUrl
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "login-link-section"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "login-link-content login-link-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_LabelledItem.default, {
    label: "Login/Register",
    url: _constants.URLS.LOGIN,
    className: "login-link"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "login-link-content right-arrow-wrapper"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: _constants.URLS.LOGIN
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "right-arrow",
    src: require("../assets/redesign/right_arrow.svg"),
    alt: ""
  })))))));
};

exports.default = _default;